import {
  createConnectionApiAction,
  createConnectorAddedSuccessStep,
  createFullWidthRowLayout,
} from './connectorSchema.helpers';

export const LangfuseSchema = {
  name: 'AI Langfuse Connector',
  steps: {
    0: {
      name: 'Step 1',
      elements: [
        {
          type: 'description',
          description:
            'Please provide the URL of your Langfuse instance and API credentials to connect. Cowbell will test the connection and download traces for AI risk visibility.',
          column: 0,
        },
        {
          name: 'baseUrl',
          label: 'Langfuse URL',
          description:
            'Please enter the URL of your Langfuse instance (e.g. https://langfuse.example.com)',
          type: 'text',
          required: true,
          column: 1,
        },
        {
          name: 'publicKey',
          label: 'API Key',
          description: 'Please enter your Langfuse public API key (pk-lf-...)',
          type: 'text',
          required: true,
          column: 2,
        },
        {
          name: 'secretKey',
          label: 'API Key Secret',
          description: 'Please enter your Langfuse secret API key (sk-lf-...)',
          type: 'password',
          required: true,
          column: 3,
        },
      ],
      layout: createFullWidthRowLayout(4),
      action: createConnectionApiAction(),
    },
    1: createConnectorAddedSuccessStep(
      'Langfuse has been successfully added as a connector. Traces will be downloaded automatically.'
    ),
  },
};
